<template>
  <!-- One area of the tree on the wish page ("Annan ort"): its leaf children as chips, its children that have
       their own sub-areas as a heading of their own (Uppsala › Centrala staden › Centrum). Data-driven: no id lists. -->
  <div class="location-group" :class="'depth-' + depth">
    <!-- the län itself is already named in the chooser above; headings start at the kommun level -->
    <h4 v-if="depth > 0">{{ node.label }}</h4>
    <LocationCheckbox v-for="child in leaves" :key="child.id" :locationId="child.id" />
    <div class="clear"></div>
    <LocationGroup v-for="child in groups" :key="child.id" :node="child" :depth="depth + 1" />
  </div>
</template>

<script>
import LocationCheckbox from '@/components/LocationCheckbox.vue'

export default {
  name: 'LocationGroup',
  components: { LocationCheckbox },
  props: {
    node: { type: Object, required: true },
    depth: { type: Number, default: 0 }
  },
  computed: {
    leaves() {
      return (this.node.children || []).filter(c => !c.children || !c.children.length)
    },
    groups() {
      return (this.node.children || []).filter(c => c.children && c.children.length)
    }
  }
}
</script>

<style lang="scss">
.location-group h4 {
  margin: 1.25rem 0 .5rem;
  font-size: 1rem;
  font-weight: 700;
}
.location-group.depth-2 h4,
.location-group.depth-3 h4 {
  font-size: .95rem;
  color: #4b4b4b;
}
</style>
